import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import GeneralHelper from '../../modules/General.js';
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import General from '../../helpers/General.js';
import moment from 'moment';

class Discounts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading:true,
			isError:false,
			unknownDiscounts:[],
			discounts:[],
		}

		this.handleEdit = this.handleEdit.bind(this);
		this.rows = this.rows.bind(this);
		this.unknownRows = this.unknownRows.bind(this);
	}

	handleEdit(id) {
		this.props.router.push(GeneralHelper.Link('/discounts/'+id));
	}

	placeholder() {
		return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
	}

    unknownRows() {
        let data = this.placeholderRow(10,4);

        this.state.unknownDiscounts.map((discount,i) => {
            data[i] =
				<tr key={`unknown-${discount.discount_code}`}>
					<td>{discount.discount_code}</td>
					<td>
                        {discount.total}
					</td>
					<td>
                        {discount.c}
					</td>
					<td>
                        {moment(General.toLocalTime(discount.created_at)).fromNow()}
					</td>
				</tr>
        })

        return data;
	}

	rows() {
		let data = this.placeholderRow(10,9);

		this.state.discounts.map((discount,i) => {
			data[i] = 
				<tr key={`discount-${discount.id}`}>
					<td>{discount.id}</td>
					<td>
						{discount.name}
					</td>
					<td>
                        {discount.generated_amount}
					</td>
					<td>
                        {discount.generated_orders}
					</td>
					<td>
						{discount.auto_update == 1 ? '-':discount.code}
					</td>
					<td>
						{discount.auto_update == 1 ? discount.amount:'-'}
					</td>
					<td>
						{discount.auto_update == 1 ? (discount.type == 'sum' ? 'Amount off':'Percent'):'-'}
					</td>
					<td>
						{moment(General.toLocalTime(discount.created_at)).fromNow()}
					</td>
					<td className="text-center">
						<div className="btn-group" role="group">
							<button type="button" onClick={(e) => {e.stopPropagation(); this.handleEdit(discount.id)}} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></button>
						</div>
					</td>
				</tr>
			
		})

		return data;
	}

	placeholderRow(rows,cols) {
		let td = [];
		for(let i = 1;i<=cols;i++) {
			td.push(<td key={i}>{this.placeholder()}</td>);
		}

		let row = [];
		for(let i = 1;i<=rows;i++) {
			row.push(<tr key={i}>{td}</tr>);
		}

		return row;
	}


	componentWillMount() {

		axios.get(`/discounts`)
		.then(res => {
			this.setState({
				...this.state,
				'isError':false,
				'isLoading':false,
				'discounts':res.data
			});
		})
		.catch(res => {
			this.setState({'isError':res.message});
		});

        axios.get(`/discounts/unknown`)
            .then(res => {
                this.setState({
                    'unknownDiscounts':res.data
                });
            });
	}

	render() {
		if(this.state.isLoading) {
			return (
				<Loading error={this.state.isError} />
			);
		}

		if(!GeneralHelper.appHasType('ecommerce')) {
			return (
				<div className="page-content">
					<Helmet title="Discounts | Crall.io" />
					<NoResult
						header="No ecommerce addon installed"
						body="Before you can use discounts you must connect Crall to your shop. Do this by installing an app."
						link="/apps"
						button="Install app"
					/>

				</div>
				)
		}

		if(this.state.discounts.length == 0 ) {
			return (

				<div className="page-content">
					<Helmet title="Discounts | Crall.io" />
					<NoResult
						header="No discounts found"
						body="You have not created a discount yet. Click the button to get stated."
						link="/discounts/new"
						button="Create my first discount"
					/>

				</div>
			);
		}

		return (
			<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-tag"></i> Discounts</span>
					<div className="page-header-actions">
				        <Link to={GeneralHelper.Link("/discounts/new")} className="btn btn-dark"><i className="icon fa-plus" style={{marginRight:'10px'}}></i>  New</Link>
				    </div>
				</div>
				<div className="page-content">
					<Helmet title="Discounts | Crall.io" />
					<OptionColumn title="Added discounts" panel={false} description="Overview of the discounts you've added.">
						<table className="table outline inherit-position">
							<thead>
							<tr>
								<th>
									Id
								</th>
								<th>
									Name
								</th>
								<th>
									Generated amount
								</th>
								<th>
									Times used
								</th>
								<th>
									Code
								</th>
								<th>
									Amount
								</th>
								<th>
									Type
								</th>
								<th>
									Created
								</th>
								<th className="text-center">
									Actions
								</th>
							</tr>
							</thead>
							<tbody>
                            {
                                this.rows()
                            }
							</tbody>
						</table>
					</OptionColumn>

					<SplitRows />

					<OptionColumn title="Unknown discounts" panel={false} description="List of discounts used in your store that Crall don't recognize.">
						<table className="table outline">
							<thead>
							<tr>
								<th>
									Code
								</th>
								<th>
									Generated amount
								</th>
								<th>
									Times used
								</th>
								<th>
									Last used
								</th>
							</tr>
							</thead>
							<tbody>
							{
								this.unknownRows()
							}
							</tbody>
						</table>
					</OptionColumn>
			</div>
			</div>
		)
		
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Discounts = connect(mapStateToProps,mapDispatchToProps)(Discounts);
export default Discounts;


// WEBPACK FOOTER //
// ./containers/discounts/discounts.js